import { render, staticRenderFns } from "./class-detail.vue?vue&type=template&id=defa3a7a&scoped=true"
import script from "./class-detail.vue?vue&type=script&lang=js"
export * from "./class-detail.vue?vue&type=script&lang=js"
import style0 from "./class-detail.vue?vue&type=style&index=0&id=defa3a7a&prod&lang=scss&scoped=true"
import style1 from "./class-detail.vue?vue&type=style&index=1&id=defa3a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defa3a7a",
  null
  
)

export default component.exports